import { ColorBar } from '../UI';
import { getLocationLineColor } from './locationLineColors';

interface LocationColorLineProps {
  // The center's name, which is also what its colour is derived from.
  name: string;
}

// Turns a center's name into its colour accent, so the trigger and the menu rows
// share one place that knows how a location's identity becomes a colour.
export const LocationColorLine = ({ name }: LocationColorLineProps) => (
  <ColorBar color={getLocationLineColor(name)} />
);
